import { ProgramType, ProgramShareType } from "@/types/programs";

export const shareDataFormatter = (program: ProgramType | ProgramShareType) => {
  return {
    title: `Check out this update from the Egyptian Food Bank’s ${program.title} on`,
    url: `${window.location.origin}/program/${program.id}`,
  };
};

export const generateCircleShareLink = (circleId: string | null, userId?: string) => {
  let link = `${window.location.origin}/?circleId=${circleId}`;
  if (userId) {
    link += `&userId=${userId}`;
  }
  return link;
};
